import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AtsIconComponent } from './icon.component';

@NgModule({
	imports: [CommonModule],
	declarations: [AtsIconComponent],
	exports: [AtsIconComponent],
})
export class AtsIconsModule {}
